import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '#services/auth/auth.service';
import { RoutePaths } from '../app.routes';
import { NavController } from '@ionic/angular';

export const authGuard: CanActivateChildFn = async (
  _childRoute: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const navCtrl = inject(NavController);

  const hasValidAccessToken = await authService.hasValidAccessToken();

  if (!hasValidAccessToken) {
    navCtrl.navigateRoot(RoutePaths.signIn, {
      animationDirection: 'back',
      replaceUrl: true,
    });

    return false;
  }

  return true;
};
